import AuthorGuidelines from "../components/Guidelines/AuthorGuidelines";

export default function Author() {
    return(
        <main className=" mt-28">
        <AuthorGuidelines />
        </main>
    )
}